// extracted by mini-css-extract-plugin
export var headerCell = "_5y-1";
export var loadingStateCell = "_5y-4";
export var rowWrapper = "_5y-3";
export var standaloneTable = "_5y-5";
export var table = "_5y-0";
export var white = "_5y-2";